import React from 'react';
import Contact from './Contact';
const ContactS = ({ color, ...props }) => (React.createElement(Contact, Object.assign({ color: color, size: 24 }, props)));
ContactS.displayName = 'ContactS'; // Fix for tsc
export default ContactS;
//# sourceMappingURL=ContactS.js.map